import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import styles from './RichTextEditor.module.css';

const modules = {
    toolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['blockquote'],
        ['link'],
        ['clean'],
    ],
};

const formats = ['bold', 'italic', 'underline', 'list', 'blockquote', 'link'];

export default function RichTextEditor({ value, onChange, placeholder = 'اكتب هنا...' }) {
    return (
        <div className={styles.editor}>
            <ReactQuill
                theme="snow"
                value={value}
                onChange={onChange}
                modules={modules}
                formats={formats}
                placeholder={placeholder}
            />
        </div>
    );
}
